import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import * as TYPES from '@/helpers/enums/view-types'
import { LK_REPORT_ROUTES as ROUTES } from './utils'
import { lkRoadmapPermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'reports',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "lk-reports.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewLKReportsLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permissions: [
            Permissions.review, // куратор
            Permissions.read, // наблюдатель
          ],
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-reports.list" */
          './LKReportsList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permissions: [
            Permissions.review, // куратор
            Permissions.read, // наблюдатель
          ],
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-reports.view" */
          './LKReportsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
